import { useEffect, useState } from "react";
import {translate} from "../../../../utils/Common"
const FormForPickUp = ({ cliente, setCliente, packageFound, setPackageFound, pickUpPackagesFound, setPickUpPackagesFound }) => {
    const [messageResult, setMessageResult] = useState('');
    const [validate, setValidate] = useState(false);

    const addPackage = () => {
        setPickUpPackagesFound([...pickUpPackagesFound, packageFound]);
        setPackageFound(null);
    }

    const validateClient = () => {
        if (cliente) {
            if (cliente === packageFound.IdCliente) return true;
            else {
                return false;
            }
        }
        else {
            setCliente(packageFound.IdCliente);
            return true;
        }
    }

    const cancelPackage = () => {
        if (pickUpPackagesFound.length === 0) setCliente(null); 
        setPackageFound(null);
    }
    
    useEffect(() => {
        if (packageFound?.IdEstatus !== 3) {
            setMessageResult(translate("dashboard.packages.pickUp.formForPickUp.incorrectStatus"));
            setValidate(false);
        }
        else if (pickUpPackagesFound.length > 0 && pickUpPackagesFound.filter((p) => p.IdPaquete === packageFound.IdPaquete ? true : false).length > 0) {
            setMessageResult(translate("dashboard.packages.pickUp.formForPickUp.duplicatePackage"));
            setValidate(false);
        }
        else if (!validateClient()) {
            setMessageResult(translate("dashboard.packages.pickUp.formForPickUp.otherClient"));
            setValidate(false);
        }
        else {
            setMessageResult('');
            setValidate(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    
    return (
        <div className="dashboardCard p-0">
            <div className="flex flex-wrap -mx-2 mx-0 mb-1 border-bottom titlePackage">
                <h6 className="ml-2 my-1">{translate("dashboard.packages.details.infoPackage")}</h6>  
            </div>
            
            <div className="flex flex-wrap -mx-2 mx-3">
                <div className="mb-3 w-6/12 md:w-6/12 mb-2">
                    <label className="mb-0" htmlFor="inputNumeroPaquete">{translate("global.numPackages")}:</label>
                    <input type="text" value={ packageFound?.Nro_Id ? packageFound?.Nro_Id : '' } readOnly className="h-9 text-sm text-sm h-11 rounded-lg border border-transparent bg-muted/60 text-sm w-full px-3 text-foreground placeholder:text-muted-foreground/70 focus-visible:outline-none focus-visible:border-primary focus-visible:bg-background focus-visible:ring-4 focus-visible:ring-primary/15 disabled:bg-transparent disabled:text-muted-foreground disabled:cursor-not-allowed font-semibold" id="inputNumeroPaquete"/>
                </div>

                <div className="mb-3 w-6/12 md:w-6/12 mb-2">
                    <label className="mb-0" htmlFor="inputCliente">{translate("global.client")}</label>
                    <input type="text" value={ packageFound?.Cliente ? packageFound?.Cliente : '' } readOnly className="h-9 text-sm text-sm h-11 rounded-lg border border-transparent bg-muted/60 text-sm w-full px-3 text-foreground placeholder:text-muted-foreground/70 focus-visible:outline-none focus-visible:border-primary focus-visible:bg-background focus-visible:ring-4 focus-visible:ring-primary/15 disabled:bg-transparent disabled:text-muted-foreground disabled:cursor-not-allowed font-semibold" id="inputCliente"/>
                </div>
                
                <div className="mb-3 w-4/12 md:w-4/12 mb-0 monto-pickup">
                    <label className="mb-0" htmlFor="inputPrecioBase">{translate("global.baseCost")}</label>
                    <input type="text" value={ packageFound?.PrecioBase !== null ? `$ ${packageFound?.PrecioBase}` : '' } readOnly className="h-9 text-sm text-sm w-full border-0 bg-transparent px-0 text-sm text-foreground font-semibold" id="inputPrecioBase"/>
                </div>

                <div className="mb-3 w-4/12 md:w-4/12 mb-0 monto-pickup">
                    <label className="mb-0" htmlFor="inputItbms">Itbms</label>
                    <input type="text" value={ packageFound?.Itbms !== null ? `$ ${packageFound?.Itbms}` : '' } readOnly className="h-9 text-sm text-sm w-full border-0 bg-transparent px-0 text-sm text-foreground font-semibold" id="inputItbms"/>
                </div>

                <div className="mb-3 w-4/12 md:w-4/12 mb-0 monto-pickup">
                    <label className="mb-0" htmlFor="inputPrecio">{translate("global.total")}</label>
                    <input type="text" value={ packageFound?.Precio !== null ? `$ ${packageFound?.Precio}` : '' } readOnly className="h-9 text-sm text-sm w-full border-0 bg-transparent px-0 text-sm text-foreground font-semibold" id="inputPrecio"/>
                </div>

                { messageResult &&
                    <div className="mb-3 w-12/12 text-center mb-0">
                        <p className="text-destructive mb-1">{ messageResult }</p>
                    </div>
                }
            </div>

            <div className="flex flex-wrap -mx-2 mx-3 mb-2">
                <div className="mb-3 text-center w-12/12 mb-0">
                    { validate ?
                        <>
                            <button className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 h-8 rounded-md px-3 text-xs bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/90 m-2" type="button" onClick={ addPackage } >{translate("global.add")}</button>
                            <button className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 h-8 rounded-md px-3 text-xs border border-secondary bg-transparent text-secondary hover:bg-secondary hover:text-secondary-foreground m-2" type="button" onClick={ () => cancelPackage() } >{translate("global.cancel")}</button>
                        </>
                        :
                        <button className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 h-8 rounded-md px-3 text-xs border border-secondary bg-transparent text-secondary hover:bg-secondary hover:text-secondary-foreground m-2" type="button" onClick={ () => setPackageFound(null) } >{translate("global.return")}</button>
                    }
                </div>
            </div>
        </div>
    );
}

export default FormForPickUp;